import { render, staticRenderFns } from "./table-ordering.vue?vue&type=template&id=a8c244ca&scoped=true&"
import script from "./table-ordering.vue?vue&type=script&lang=ts&"
export * from "./table-ordering.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8c244ca",
  null
  
)

export default component.exports